import _asyncToGenerator from "D:/JG/jg/IWMS5.0/SRM/GIT/SRM.VUE/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import "core-js/modules/es.array.map.js";
import "regenerator-runtime/runtime.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import SettingFieldTable from '@/views/mixin/SettingFieldTable';
import MesTable from '@/api/MesTable/index.js';
import fastSearch from '@/components/fast-search';
import { assign } from 'xe-utils';
import util from '@/libs/util';
import { ExportListData } from '@/api/DeliveryNoteReport';
import store from '@/store/index';
var mesTable = MesTable('DeliveryNoteReport/GetDeliveryNoteReport');
export default {
  mixins: [SettingFieldTable({
    defaultLoadDataApi: function defaultLoadDataApi(e) {
      return mesTable.LoadData(e);
    }
  })],
  components: {
    fastSearch: fastSearch
  },
  data: function data() {
    return {
      mainTable: [],
      code: '',
      formData: {
        Page: 1,
        // 当前页
        Limit: 15,
        // 分页大小
        LIST_ROUTE: store.getters.routerPath,
        Data: {
          VENDOR_CODE: util.getVENDOR_CODE(),
          ORGANIZE_ID: util.cookies.get('ORG_ID')
        }
      },
      pageInfo: {
        TotalCount: null,
        PageSize: 10,
        PageIndex: 1
      },
      times: []
    };
  },
  created: function created() {
    console.log('columnsWhere');
    this.getLoadData();
  },
  methods: {
    // 搜索
    search: function search() {
      this.formData.Page = this.pageInfo.PageIndex;
      this.getLoadData();
    },
    handleDate: function handleDate() {
      // console.log('times',this.times);
      if (this.times !== null) {
        this.formData.Data.START_DATE = this.times[0];
        this.formData.Data.END_DATE = this.times[1];
      } else {
        this.formData.Data.START_DATE = null;
        this.formData.Data.END_DATE = null;
      }
    },
    TranslationSTATUS: function TranslationSTATUS(STATUS) {
      switch (STATUS) {
        case 1:
          return '未处理';
        // 未处理

        case 2:
          return '审核';
        // 审核

        case 3:
          return '作废';
        // 作废

        case 4:
          return '在途';
        // 在途

        case 5:
          return '收货';
        // 收货
      }
    },
    TranslationDN_TYPE: function TranslationDN_TYPE(DN_TYPE) {
      switch (DN_TYPE) {
        case '1':
          return '采购送货单';
        // 未处理

        case '2':
          return '委外送货单';
        // 审核
      }
    },
    handelExportListData: function handelExportListData() {
      var _this = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var res;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _this.$openLoading();

                _context.next = 3;
                return ExportListData(_this.formData);

              case 3:
                res = _context.sent;

                _this.$closeLoading(); // console.log('导出res',res);


                if (res.code === 0) {
                  window.open(_this.$store.getters.getVUE_APP_DOWN + res.data);
                } else {
                  _this.$message.warning('数据导出失败----' + res.message);
                }

              case 6:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }))();
    },
    // 点击页size
    handleSizeChange: function handleSizeChange(size) {
      console.log('点击size');
      this.pageInfo.PageSize = size;
      this.getLoadData();
    },
    // 点击页码
    handleCurrentChange: function handleCurrentChange(index) {
      this.pageInfo.PageIndex = index;
      this.getLoadData();
    },
    getLoadData: function getLoadData() {
      var _this2 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
        var res;
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _this2.loading = true;
                _this2.formData.Page = _this2.pageInfo.PageIndex;
                _this2.formData.Limit = _this2.pageInfo.PageSize;
                _context2.next = 5;
                return mesTable.LoadData(_this2.formData);

              case 5:
                res = _context2.sent;
                console.log('表格数据 res', res);
                _this2.loading = false;

                if (res.code === 0) {
                  _this2.mainTable = res.data.Items.map(function (v) {
                    v.statusStyle = util.func.switchColor(v);
                    return v;
                  });
                  _this2.pageInfo.TotalCount = res.data.TotalCount;
                  _this2.pageInfo.PageSize = res.data.PageSize;
                  _this2.pageInfo.PageIndex = res.data.PageIndex;
                } else {
                  _this2.$message.warning(res.message);
                }

              case 9:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2);
      }))();
    },
    fastSearch: function fastSearch(searchData) {
      // console.log('searchData',searchData);
      // let Data = this.mergeParamList(searchData.ParamList, this.formData.Data)
      // let data = {}
      // searchData.ParamList.forEach(item => {
      //     let obj = {}
      //     obj[item.PARAM_NAME] = item.PARAM_VALUE
      //     assign(data,obj)
      // });
      // console.log('data',data);
      // assign(this.formData.Data,data)
      // data.ORGANIZE_ID = util.cookies.get('ORG_ID')
      // this.formData.Data = data
      // console.log('this.formData',this.formData);
      this.formData.ParamList = this.mergeParamList(searchData.ParamList, this.formData.ParamList);
      this.getLoadData();
    }
  }
};